var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageSuccess64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconSuccess64",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,0 C49.6652788,0.0188967309 63.9811033,14.3347212 64,32 C64,49.673112 49.673112,64 32,64 C14.326888,64 0,49.673112 0,32 C0,14.326888 14.326888,0 32,0 Z M32,4.57142857 C16.8516183,4.57142857 4.57142857,16.8516183 4.57142857,32 C4.57142857,47.1483817 16.8516183,59.4285714 32,59.4285714 C47.141593,59.4121946 59.4121946,47.141593 59.4285714,32 C59.4285714,16.8516183 47.1483817,4.57142857 32,4.57142857 Z M42.1485714,21.5702857 C43.0093982,20.679006 44.2841528,20.3215568 45.4828823,20.635324 C46.6816117,20.9490913 47.6177659,21.8852454 47.9315331,23.0839749 C48.2453003,24.2827044 47.8878511,25.557459 46.9965714,26.4182857 L46.9965714,26.4182857 L28.7108571,44.704 C27.378254,46.0362614 25.2202538,46.0434071 23.8788571,44.72 L23.8788571,44.72 L14.736,35.7028571 C13.387794,34.3729555 13.3729555,32.2019203 14.7028571,30.8537143 C16.0327588,29.5055083 18.203794,29.4906698 19.552,30.8205714 L19.552,30.8205714 L26.2697143,37.4491429 L42.1485714,21.5725714 Z",
    id: "Combined-Shape-Copy-2",
    fill: "#177D3D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageSuccess64);
export default __webpack_public_path__ + "static/media/messageSuccess64.f1e1013534489b83767882bdb4ae9d66.svg";
export { ForwardRef as ReactComponent };